import script from "./NetSms.vue?vue&type=script&setup=true&lang=js"
export * from "./NetSms.vue?vue&type=script&setup=true&lang=js"

import "./NetSms.vue?vue&type=style&index=0&id=66739d12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66739d12"]])

export default __exports__